import { useAsyncData } from 'nuxt/app'
import type { Podcast } from '~/types/podcasts'
import type { Episode, EpisodeListItem } from '~/types/episodes'

export function usePodcast(podcastId: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData(`podcast-${podcastId}`, (): Promise<Podcast> => $fetch(`/api/podcasts/${podcastId}`), {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
  })
}

export function useEpisode(podcastId: string, episodeId: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData(
    `episode-${episodeId}`,
    (): Promise<Episode> => $fetch(`/api/podcasts/${podcastId}/episodes/${episodeId}`),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}

export function useEpisodes(
  podcastId: string,
  {
    search,
    offset = 0,
    limit = 10,
  }: {
    search: string
    offset: number
    limit: number
  }
) {
  const nuxtApp = useNuxtApp()
  return useAsyncData(
    `podcast-${podcastId}-episodes`,
    (): Promise<EpisodeListItem[]> =>
      $fetch(`/api/podcasts/${podcastId}/episodes`, {
        query: {
          search,
          offset,
          limit,
        },
      }),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}
